import type { DefaultErrorDetails, Result } from '@avalara/types/index';

function toResult<S, E = DefaultErrorDetails>(
  value: S | null,
  message = 'Unhandled server error',
  status = 500,
  details?: E,
): Result<S, E> {
  if (value != null) {
    return { ok: true, value };
  }

  return { ok: false, message, status, details };
}

export default toResult;
